import React, { useMemo } from 'react';
import {LandingPageContent, Images} from '@/constants';
import { useWindowDimensions } from '@/hooks';
import { screenSize } from '@/theme';

interface StatsProps {
  id?: string;
}
export const Stats: React.FC<StatsProps> = ({id}) => {
  const {width} = useWindowDimensions();
  const mappingData = useMemo(() => {
    if (width > screenSize.xl) {
      return LandingPageContent.stats;
    }
    // change the order
    return [...LandingPageContent.stats.slice(0,2), LandingPageContent.stats[3], LandingPageContent.stats[2]]
  }, [width]);
  return (
    <div id={id} className="flex relative md:px-4 justify-center pt-4 md:pt-6 pb-10 md:pb-16">
      <div className="flex relative items-end w-full max-w-[1100px] min-h-[280px] sm:min-h-auto">
        <img
          alt=""
          src={Images.bg_banner}
          className="absolute left-0 object-cover right-0 bottom-0 top-0 w-full min-h-[280px] sm:min-h-auto sm:h-[100%] 2xl:h-[80%] 2xl:top-auto rounded-none sm:rounded-md lg:rounded-xl xl:rounded-2xl -z-10"
        />
        <div className="grid grid-cols-3 h-full items-center xl:grid-cols-4 xl:grow gap-4 sm:gap-6 md:gap-8 p-2 sm:p-4 md:p-6 2xl:h-[80%] 2xl:self-end min-h-[280px] sm:min-h-auto">
          {mappingData.map(item => (
            <Stat key={item.label} {...item} />
          ))}
        </div>
        <img
          alt="doctor-image"
          src={Images.doctor_1}
          className="absolute xl:static right-0 bottom-0 object-bottom object-contain w-[189px] h-[160px] md:w-[230px] md:h-[193px] lg:w-[270px] lg:h-[220px] 2xl:w-[400px] 2xl:h-[350px] xl:self-end"
        />
      </div>
    </div>
  );
};

const Stat: React.FC<(typeof LandingPageContent)['stats'][number]> = ({
  label,
  image,
  stat,
}) => {
  return (
    <div className="flex flex-col gap-1 items-center">
      <img
        alt={`stat-image-${label}`}
        src={image}
        className="size-[40px] sm:size-[60px] object-contain"
      />
      <p className="text-lg sm:text-2xl 3xl:text-3xl font-PoppinsSemiBold text-ui_blue">
        {stat}
      </p>
      <p className="text-[9px] xs:text-[10px] sm:text-sm lg:text-base font-Body text-ui_blue opacity-80 text-center whitespace-nowrap -mt-0.5">
        {label}
      </p>
    </div>
  );
};
